var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from "react";
import BootstrapToast from "react-bootstrap/Toast";
import styled from "styled-components";
import { SuccessIcon, CloseIcon } from "../../assets/icons/icons";
import Logo from "../../assets/icons/logo";
import { SecondaryText, Title } from "../../designSystem";
import colors from "../../designSystem/colors";
import sizes from "../../designSystem/sizes";
var StyledToast = styled(BootstrapToast)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  background: none;\n  color: rgba(255, 255, 255, 0.64);\n  z-index: 1000;\n\n  @media (max-width: ", "px) {\n    width: 90%;\n    max-width: 90%;\n    top: 70px;\n    left: 5%;\n    right: 5%;\n    height: 80px;\n  }\n\n  @media (min-width: ", "px) {\n    top: 70px;\n    right: 30px;\n    width: 343px;\n    height: 80px;\n  }\n"], ["\n  position: fixed;\n  background: none;\n  color: rgba(255, 255, 255, 0.64);\n  z-index: 1000;\n\n  @media (max-width: ", "px) {\n    width: 90%;\n    max-width: 90%;\n    top: 70px;\n    left: 5%;\n    right: 5%;\n    height: 80px;\n  }\n\n  @media (min-width: ", "px) {\n    top: 70px;\n    right: 30px;\n    width: 343px;\n    height: 80px;\n  }\n"])), sizes.lg, sizes.lg);
var Body = styled(BootstrapToast.Body)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  background: #08090e;\n  border: 1px solid #2b2b2b;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  @media (max-width: ", "px) {\n    width: 100%;\n    padding-left: 20px;\n    padding-right: 25px;\n  }\n"], ["\n  height: 100%;\n  background: #08090e;\n  border: 1px solid #2b2b2b;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  @media (max-width: ", "px) {\n    width: 100%;\n    padding-left: 20px;\n    padding-right: 25px;\n  }\n"])), sizes.lg);
var IconCircle = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 100px;\n  margin-right: 10px;\n\n  background-color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 100px;\n  margin-right: 10px;\n\n  background-color: ", ";\n"])), function (props) {
    return props.type === "error"
        ? "rgba(255, 56, 92, 0.16)"
        : "rgba(22, 206, 185, 0.16)";
});
var BaseToast = function (_a) {
    var type = _a.type, title = _a.title, subtitle = _a.subtitle, props = __rest(_a, ["type", "title", "subtitle"]);
    var icon = useMemo(function () {
        switch (type) {
            case "success":
                return _jsx(SuccessIcon, { color: colors.green }, void 0);
            case "error":
                return _jsx(CloseIcon, { color: colors.red }, void 0);
            case "claim":
                return _jsx(Logo, {}, void 0);
        }
    }, [type]);
    // When the caller doesnt specify the `show` variable
    // it means that the caller doesnt want to control the state of the Toast
    // so we need to manage the `show` state internally
    var _b = useState(true), controlledShow = _b[0], setControlledShow = _b[1];
    var show = props.show, propsOnClose = props.onClose;
    var onClose = useCallback(function () {
        propsOnClose && propsOnClose();
        !show && setControlledShow(false);
    }, [propsOnClose, show]);
    return (_jsx(StyledToast, __assign({ show: Boolean(props.show) || controlledShow, onClose: onClose }, props, { children: _jsxs(Body, { children: [_jsx(IconCircle, __assign({ type: type }, { children: icon }), void 0), _jsxs("div", __assign({ style: { flex: 1 }, className: "d-flex flex-column" }, { children: [_jsx(Title, { children: title }, void 0), _jsx(SecondaryText, { children: subtitle }, void 0)] }), void 0), _jsx(CloseIcon, { containerStyle: {
                        cursor: "pointer",
                        marginRight: 16,
                    }, onClick: onClose }, void 0)] }, void 0) }), void 0));
};
export default BaseToast;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=BaseToast.js.map